import { Box, Modal, Typography } from "@mui/material";
const style = {
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 650,
    borderRadius: "10px",
    bgcolor: "#1D1D1D",
    border: "8px solid #3A3A3A",
    boxShadow: 24,
    p: 4,
  };
 
interface FilterResetModalProps {
    open: boolean,
    resetFilter?: () => void,
    handleClose?: () => void
} 
const FilterResetModal = ({open, resetFilter, handleClose}:FilterResetModalProps) => {
  return (
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid="filter-modal"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            data-testid="modal-modal-title"
            style={{ fontWeight: "bold", fontSize: "28px", color: "white" }}           
          >
            Are you sure you want to reset filters?
          </Typography>
          <Typography
            id="modal-modal-description"
            data-testid="modal-modal-description"
            sx={{ mt: 1, color: "white" }}
          >
            This cannot be undone and you will loose all you filters selections
          </Typography>
          <div className="flex w-full justify-end mt-6">
            <button
              name="Cancel"
              onClick={handleClose}
              className="cancelFilterResetModalButton"
              data-testid="cancel-button"

              
            >
              Cancel
            </button>
            <button onClick={resetFilter} className="resetFilterModalButton" data-testid="reset-button">
              Reset Filters
            </button>
          </div>
        </Box>
      </Modal>
  )
}

export default FilterResetModal
